import { Icon, ProfileMenu, NavigationLink as RivendellNavigationLink } from '@nordlayer/rivendell-ui';
import { LOGOUT_PATH } from 'routing/routes/auth/constants';
import { jsx as _jsx } from "react/jsx-runtime";
export var UserProfileNavigationItem = function UserProfileNavigationItem(_ref) {
    var fullName = _ref.fullName;
    return /*#__PURE__*/ _jsx(ProfileMenu, {
        isActive: false,
        fullName: fullName,
        userRole: null,
        children: /*#__PURE__*/ _jsx(RivendellNavigationLink, {
            prefix: /*#__PURE__*/ _jsx(Icon, {
                name: "logout16"
            }),
            size: "sm",
            href: LOGOUT_PATH,
            "data-testid": "navigation-item-logout",
            children: "Log out"
        })
    });
};
